import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import Modal from "react-modal";
import cogoToast from "@successtar/cogo-toast";
import DocVault from "../DocVault";
import ServiceRequestUpdateForm from "../../components/ServiceRequestUpdateForm";

const customStylesModal = {
  content: {
    padding: "5px 5px",
    border: "thick solid black",
    overflowX: "auto"
  }
};

const docVaultModal = {
  content: {
    margin: "10%",
    padding: "5px 5px",
    backgroundImage: "rgba(255,255,255,0.5)",
    border: "thick solid black",
    inset: "40px",
    overflowX: "auto"
  }
};

function RequestItem({ request, submitterID, complete, agents, clients, rerender, active }) {
  const [formData, setFormData] = useState({
    editActivated: false,
    editModalIsOpen: false,
    showAddtlEdits: false,
    openEditModal: false,
    active: false,
    completed: false,
    docIDArray: [],
    openDocVaultModal: false,
    clientID: "",
    policyType: "",
    editableRequest: null,
    editablePolicy: ""
  });

  useEffect(() => {
    console.log("Contact Card Mounted");
    const timer = setTimeout(() => {
      setFormData((prev) => ({
        ...prev,
        active: request.active,
        completed: request.completed
      }));
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const completeRequest = (e) => {
    e.preventDefault();

    API.updateServiceRequest(request._id, {
      active: false,
      completed: true,
      completer: submitterID
    })
      .then((_res) => {
        cogoToast.success("You've updated this request!");
        complete();
      })
      .catch((_err) => alert("The update did not go through!"));
  };

  const gatherVaultDocs = (e, docIDArray, policyID, policyType) => {
    e.preventDefault();
    console.log("Gathering Documents from Vault for: ");
    console.log(docIDArray);
    setFormData((prev) => ({
      ...prev,
      docIDArray: docIDArray,
      openDocVaultModal: true,
      clientID: policyID,
      policyType: policyType
    }));
  };

  const openDocVaultModal = (e) => {
    e.preventDefault();
    if (formData.openDocVaultModal === false) {
      setFormData((prev) => ({
        ...prev,
        openDocVaultModal: true
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        openDocVaultModal: false,
        docIDArray: [],
        policyID: ""
      }));
    }
  };

  const openEditModal = (data) => {
    console.log("Opening up Edit Modal for Data ID: " + data._id);
    console.log(data);
    if (formData.openEditModal === false) {
      setFormData((prev) => ({
        ...prev,
        openEditModal: true,
        editableRequest: data
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        openEditModal: false
      }));
    }
  };

  const closeEditModal = (e) => {
    e.preventDefault();
    if (formData.openEditModal === true) {
      setFormData((prev) => ({
        ...prev,
        openEditModal: false,
        editablePolicy: ""
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        openEditModal: true
      }));
    }
  };

  return (
    <tr>
      <Modal
        isOpen={formData.openDocVaultModal}
        onRequestClose={(e) => openDocVaultModal(e)}
        style={docVaultModal}
      >
        <DocVault
          docIDArray={formData.docIDArray}
          rootPolicyID={formData.clientID}
          rootPolicyType={formData.policyType}
          closeModal={(e) => openDocVaultModal(e)}
        />
      </Modal>

      <Modal
        isOpen={formData.openEditModal}
        onRequestClose={(e) => closeEditModal(e)}
        style={customStylesModal}
      >
        <button
          style={{
            width: "10%",
            marginLeft: "80%",
            textAlign: "center",
            backgroundColor: "white",
            color: "black"
          }}
          onClick={(e) => closeEditModal(e)}
        >
          X
        </button>
        <ServiceRequestUpdateForm
          request={formData.editableRequest}
          agents={agents}
          clients={clients}
          rerender={rerender}
        />
      </Modal>

      <td>{request.name}</td>
      <td>{request.email}</td>
      <td style={{ width: "150px" }}>
        {request.phone && request.phone.length === 10
          ? request.phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
          : request.phone}
      </td>
      <td style={{ width: "150px" }}>
        {request.type ? (
          <div>
            {request.type === "policy-review" ? "Policy Review" : null}
            {request.type === "req-mortgage-doc" ? "Mortgagee Request" : null}
            {request.type === "renewal-quote" ? "Renewal Q" : null}
            {request.type === "billing" ? "Billing" : null}
            {request.type === "req-lienholder-doc" ? "Lienholder" : null}
            {request.type === "general" ? "General" : null}
            {request.type === "req-other" ? "Other" : null}
          </div>
        ) : null}
      </td>
      <td
        style={{
          wordWrap: "break-word",
          width: "300px",
          maxWidth: "500px",
          whiteSpace: "normal"
        }}
      >
        {request.message}
      </td>
      <td style={{ width: "100px" }}>
        <button className="btn btn-secondary" onClick={(_e) => openEditModal(request)}>
          Edit
        </button>
      </td>
      <td style={{ width: "100px" }}>
        {request.documents.length > 0 ? (
          <i
            onClick={(e) => gatherVaultDocs(e, request.documents, request._id, "servicerequest")}
            className="fa fa-folder-open fa-2x"
            aria-hidden="true"
          ></i>
        ) : (
          <i
            onClick={(e) => gatherVaultDocs(e, request.documents, request._id, "servicerequest")}
            className="fa fa-folder fa-2x"
            aria-hidden="true"
          ></i>
        )}
      </td>
      <td style={{ width: "120px" }}>
        {active ? (
          "Completed."
        ) : (
          <button className="btn btn-primary btn-sm" onClick={completeRequest}>
            Complete
          </button>
        )}
      </td>
    </tr>
  );
}

export default RequestItem;
